module.exports = __webpack_public_path__ + "img/pdf-file.936e568e.svg";